import React, { createContext, useContext, useState } from "react"

const CreateAccountContext = createContext({})

export const CreateAccountProvider = ({ children }) => {
  const [coordinate, setCoordinate] = useState({ latitude: 0, longitude: 0 })
  const [address, setAddress] = useState(null)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  })

  const updateCoordinate = ({ latitude, longitude }) =>
    setCoordinate({ latitude, longitude })

  const updateFormData = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  return (
    <CreateAccountContext.Provider
      value={{
        updateFormData,
        formData,
        coordinate,
        updateCoordinate,
        address,
        setAddress,
      }}>
      {children}
    </CreateAccountContext.Provider>
  )
}

export const useCreateAccount = () => {
  const context = useContext(CreateAccountContext)
  if (!context) {
    throw new Error(
      "useCreateAccount must be used within CreateAccountProvider"
    )
  }
  return context
}
